import React, {
  Fragment,
  memo,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";

// Provider
import { AppContext } from "../../../../../components/AppProvider";

// Utils

// UI
import { openAlertPopup } from "../../../../Layout";

// Temp Images

import {
  PostApi1113,
  PostApi1114,
} from "../../../../../modules/network/padoPost";
import { MemoTextArea } from "../../../../../components/UI/TextArea/MemoTextArea";

export default memo(props => {
  const { setMod, searchDtParam, mdcnTypeParam, setMdcnDate } = props;

  // 오늘날짜
  let toDay = new Date();

  let year = toDay.getFullYear();
  let month = toDay.getMonth() + 1;
  let date = toDay.getDate();

  let nowDate = year + "-" + month + "-" + date;

  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [searchDt, setSearchDt] = useState();
  const [result, setResult] = useState("");

  const [prevDt, setPrevDt] = useState();
  const [nextDt, setNextDt] = useState();

  const request1113 = (userinfo, cfg, searchDt, mdcnType) => {
    let seachMonth = searchDt.split("-")[1];
    let searchDate = searchDt.split("-")[2];

    if (seachMonth.length < 2) {
      seachMonth = "0" + seachMonth;
    }

    if (searchDate.length < 2) {
      searchDate = "0" + searchDate;
    }

    $("#toDayText").text("(" + seachMonth + "/" + searchDate + ") ");

    PostApi1113(userinfo, cfg, phonecfg, searchDt, mdcnType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result.length === 0) {
            // setMod("SETTING");
          }

          setResult(res);
          setSearchDt(searchDt);

          if (res.prevDt === "Empty") {
            $(".slick-prev").css("opacity", "0.4");
          } else {
            $(".slick-prev").css("opacity", "");
          }

          if (res.nextDt === "Empty") {
            $(".slick-next").css("opacity", "0.4");
          } else {
            $(".slick-next").css("opacity", "");
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const setSlider = () => {
    let initialSlideValue = 0;

    if ($(".medic-list-slide").hasClass("slick-initialized")) {
      $(".medic-list-slide").slick("unslick"); //슬릭해제
    }

    $(".medic-list-slide").slick({
      dots: false,
      arrows: false,
      infinite: false,
      initialSlide: initialSlideValue,
      prevArrow: $(".slick-prev"), // 이전 화살표 모양 설정
      nextArrow: $(".slick-next"), // 다음 화살표 모양 설정
      draggable: false,
    });
  };

  useEffect(() => {
    if (searchDtParam) {
      request1113(userinfo, cfg, searchDtParam, "BS");
    } else {
      request1113(userinfo, cfg, nowDate, "BS");
    }
    setSlider();
  }, []);

  const clickPrevBtn = result => {
    if (result.prevDt === "Empty") {
      openAlertPopup("마지막 알람입니다.");
    } else {
      request1113(userinfo, cfg, result.prevDt, "BS");
      setMdcnDate(result.prevDt);
      setSlider();
    }
  };

  const clickNextBtn = result => {
    if (result.nextDt === "Empty") {
      openAlertPopup("마지막 알람입니다.");
    } else {
      request1113(userinfo, cfg, result.nextDt, "BS");
      setMdcnDate(result.nextDt);
      setSlider();
    }
  };

  return (
    <Fragment>
      <div className="section-box">
        <div className="device-state-info bmag">
          <span>
            {/* <em>어제(6/12) </em> */}
            <em id="toDayText" className="on">
              오늘(6/13){" "}
            </em>
            {/* <em>내일(6/14) </em> */}
          </span>
          복용한 약을 입력해주세요.
        </div>

        <div className="medicine-setting-list" style={{ position: "relative" }}>
          <div className="medic-list-slide">
            {/* 약 리스트 세트 */}
            {result != "" && (
              <MedicineSetBox
                result={result}
                toDay={searchDt}
                setSearchDt={setSearchDt}
                setSlider={setSlider}
              />
            )}
            {/* 약 리스트 세트 */}
          </div>
          <button
            type="button"
            onClick={() => clickPrevBtn(result)}
            className="slick-prev">
            Previous
          </button>
          <button
            type="button"
            onClick={() => clickNextBtn(result)}
            className="slick-next">
            Next
          </button>
        </div>
      </div>

      <div className="section-box">
        <div className="sub-title">특이사항</div>
        <div className="issue-text-box">
          {/* <textarea
            className="textarea-box gray"
            style={{ resize: "none" }}
            placeholder="특이사항 및 메모를 입력해주세요"
            defaultValue={result !== "" && { result }.result.mdcnMemo}
          /> */}

          <MemoTextArea result={result} />
        </div>
      </div>

      <div className="section-box">
        <div className="two-btns-area">
          <a href={void 0}>취소</a>
          <a className="btn-aftersave btn-saveconfirm">확인</a>
        </div>
      </div>
    </Fragment>
  );
});

const MedicineSetBox = props => {
  const { result, toDay, setSearchDt, setSlider } = props;
  const { userinfo, cfg } = useContext(AppContext);

  useEffect(() => {
    //슬라이드 후 위 오늘(날짜) 표시 변경
    $(".medic-list-slide").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        $(".device-state-info > span em").hide();
        $(".device-state-info > span em").eq(currentSlide).show();
      }
    );
  }, []);

  if (result.result.length > 0) {
    return (
      <Fragment>
        <div className="medic-setbox">
          {/* 복용 약품 세트 */}
          {result.result.map((m, i) => (
            <MedicineBox
              mdcnCyclDtlNm={m.mdcnCyclDtlNm}
              mdcnIds={m.mdcnIds}
              mdcnYn={m.mdcnYn}
              toDay={toDay}
              length={m.length}
              key={i}
            />
          ))}
          {/* 복용 약품 세트 */}
        </div>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <div className="medic-setbox">
        <div>
          <div className="time">복약 없음</div>
        </div>
      </div>
    </Fragment>
  );
};

const MedicineBox = props => {
  const { mdcnCyclDtlNm, mdcnIds, mdcnYn, toDay } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [mdcnToggle, setMdcnToggle] = useState(mdcnYn === "Y" ? true : false);
  const [activeBtn, setActiveBtn] = useState(true);

  // procType C: Cancel, I: Insert
  const request1114 = (userinfo, cfg, procType, mdcnIds, mdcnDate) => {
    PostApi1114(userinfo, cfg, phonecfg, procType, mdcnIds, mdcnDate)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setMdcnToggle(!mdcnToggle);
        } else {
          console.log("LOGOUT: ", res);
        }
        setActiveBtn(true);
      })
      .catch(err => {
        console.log(err);
        setActiveBtn(true);
      });
  };

  // 복약 토글 이벤트
  const clickTakeMdcn = (mdcnIds, mdcnDate) => {
    // 중복 클릭 방지
    if (activeBtn) {
      request1114(userinfo, cfg, mdcnToggle ? "C" : "I", mdcnIds, mdcnDate);
    }
    setActiveBtn(false);
  };

  // 초기화 작업?
  const initiallize = () => {
    // mdcnToggle 초기화
    setMdcnToggle(mdcnYn === "Y" ? true : false);
    //activeBtn 초기화
    setActiveBtn(true);
  };

  useLayoutEffect(() => {
    initiallize();
  }, [toDay]);

  return (
    <Fragment>
      {/* <div className= {(mdcnYn === "Y") ? "test on" : "test"}> */}
      {/* <div className="test" id={toDay + mdcnCyclDtlNm}> */}
      <div
        className={`test ${mdcnToggle ? "on" : ""}`}
        id={toDay + mdcnCyclDtlNm}>
        <div className="time">
          {mdcnCyclDtlNm} <u></u>
        </div>
        <a
          className="btn-takemedic"
          onClick={e => clickTakeMdcn(mdcnIds, toDay)}>
          <span className="before">복용완료</span>
          <span className="after">
            <i></i>복용
          </span>
        </a>
      </div>
    </Fragment>
  );
};
